import PublicAppVars from "utils/PublicAppVars.js";

export const hasMaxTravelCards = (travelCardCount) => (Boolean(PublicAppVars.MAX_TRAVEL_CARD_LIMIT)
	&& (travelCardCount >= PublicAppVars.MAX_TRAVEL_CARD_LIMIT));
